<ll-titulo>Avance planes de Clase</ll-titulo>
<ll-toolnavbar>
    <filtro-plan-clase-admin (filtro)="onSelect($event)"></filtro-plan-clase-admin>
</ll-toolnavbar>

<div *ngIf="planId">
    <plan-clase-admin [onlyShared]="true" [showButtonCompartir]="true" [planPersonalId]="planId"></plan-clase-admin>
</div>
